module.exports = __webpack_public_path__ + "img/sharks-xv-logo-icon.5c4573e6.png";